import { render } from "./CatalogInsuredCardDialog.vue?vue&type=template&id=132b68cc"
import script from "./CatalogInsuredCardDialog.vue?vue&type=script&lang=js"
export * from "./CatalogInsuredCardDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\AgentModule\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__